import { render, staticRenderFns } from "./CommentsRelatedWidget.vue?vue&type=template&id=c319bcec"
import script from "./CommentsRelatedWidget.vue?vue&type=script&lang=js"
export * from "./CommentsRelatedWidget.vue?vue&type=script&lang=js"
import style0 from "./CommentsRelatedWidget.vue?vue&type=style&index=0&id=c319bcec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports